var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"hero"},[_c('div',{staticClass:"description"},[_c('RichTextRenderer',{attrs:{"document":_vm.content}})],1)]),_vm._v(" "),_c('page-tabs',{attrs:{"named":"store","tabs":_vm.page.tabs}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }